export default {
  followUpRules: [],
  pagination: {},
  followUpRule: {}
}
